export default __webpack_public_path__ + "static/media/ResponsibilityPage.d548cb15.jpg";